import { createRouter, createWebHistory } from 'vue-router'

import { isMobile } from '@/network/device'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => !isMobile() ? import('../views/index/index.vue') : import('../views/index/indexmobile.vue'),
  },
  {
    path: '/km',
    name: "km",
    component: () => !isMobile() ? import('../views/km/km.vue') : import('../views/km/kmmobile.vue'),
  },
  {
    path: '/lit',
    name: "lit",
    component: () => !isMobile() ? import('../views/lit/lit.vue') : import('../views/lit/litmobile.vue'),
  },
  {
    path: '/end',
    name: 'end',
    component: () => !isMobile() ? import('../views/end/end.vue') : import('../views/end/end.vue'),
  },
  {
    path: '/tos_cn',
    name: "tos_cn",
    component: () => import('../views/index/tos_cn.vue'),
  },
  {
    path: '/tos_en',
    name: "tos_en",
    component: () => import('../views/index/tos_en.vue'),
  },
  {
    path: '/policy_cn',
    name: "policy_cn",
    component: () => import('../views/index/policy_cn.vue'),
  },
  {
    path: '/policy_en',
    name: "policy_en",
    component: () => import('../views/index/policy_en.vue'),
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

function getFaviconPath(path, hostname = '') {
  const normalizedHostname = hostname.toLowerCase();

  if (normalizedHostname.includes('bigkraken')) {
    return '/favicon_cn.ico';
  }

  if (path.includes('/km')) {
    return '/km.ico';
  }

  if (path.includes('/lit')) {
    return '/lit.ico';
  }

  return '/favicon.ico';
}

function setFavicon(path) {
  let icon = document.getElementById('dynamic-favicon');
  if (!icon) {
    icon = document.createElement('link');
    icon.rel = 'icon';
    icon.type = 'image/x-icon';
    icon.id = 'dynamic-favicon';
    document.head.appendChild(icon);
  }

  icon.href = `${path}?v=${Date.now()}`;
}

// 动态切换 favicon
router.afterEach((to) => {
  const icoPath = getFaviconPath(to.path, window.location.hostname);
  window.__PAYWEB_FAVICON_PATH__ = icoPath;
  setFavicon(icoPath);
});

export default router
